import { assert, assertObject } from '@Utils/assert';

import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfStructureOptionsDialog } from './StructureOptionsDialogConstants';

// eslint-disable-next-line import/prefer-default-export
export function updateStructureOptionsDialog(payload) {
  assertObject(payload, 'payload');
  assert(
    payload.id !== undefined,
    `StructureOptions shared between several part of application
    and data has to be unique between that parts, unique "id" for each part require`
  );

  return updateDialog({
    showMore: true,
    ...payload,
    dialogType: typeOfStructureOptionsDialog,
  });
}
